/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontFeaturedSection_products$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontHome_products$ref: FragmentReference;
export type StorefrontHome_products = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +serviceId: ?string
    |}
  |}>,
  +$fragmentRefs: StorefrontFeaturedSection_products$ref,
  +$refType: StorefrontHome_products$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontHome_products",
  "type": "DealerStorefrontQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "DealerStorefrontQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_products",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8ff47b8ca9e101479ded1d4a9355a1ae';
module.exports = node;
